<template>
  <div>
    <div v-for="(d, i) in divisions" :key="i" class="mb-2">
      <div class="flex justify-between items-center">
        <p class="text-base font-bold">
          <span>{{ d }} </span>
          <template v-if="divisionInfo[d].classes">
            <span class="text-sm font-medium" v-if="divisionInfo[d].classes[0].division_group">({{ divisionInfo[d].classes[0].division_group }})</span>
          </template>
        </p>
        <p class="text-xs" v-if="divisionInfo[d].subdivision_champions">Sub Champs: {{ divisionInfo[d].subdivision_champions}}</p>
      </div>
      <template v-if="divisionInfo[d].sub_divisions">
        <div class="mb-1" v-for="(s, j) in divisionInfo[d].sub_divisions" :key="j">
          <div class="flex items-center justify-between">
            <p v-if="!s.name" class="text-md font-bold ml-2">Overall</p>
            <p class="text-md font-bold ml-2">{{ s.name }} </p>
            <!--<span class="text-xs font-normal" v-if="s.break_by">by {{ s.break_by }}</span>-->
          </div>
          <p class="text-xs pb-0.5 ml-2 flex justify-between" v-for="(c, k) in s.classes" :key="k">
            <span>{{ c.className }}</span>
            <span v-if="c.entryType === 'standard'">{{ c.break_type }}</span>
          </p>
        </div>
      </template>
      <p v-else class="text-xs pb-0.5 flex justify-between" v-for="(c, j) in divisionInfo[d].classes" :key="j">
        <span>{{ c.className }}</span>
        <span>{{ c.break_type }}</span>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    classList: Array
  },
  data () {
    return {

    }
  },
  computed: {
    divisions () {
      if (this.classList) {
        return [...new Set(this.classList.map(c => c.division))]
      } else {
        return []
      }
    },
    divisionInfo () {
      let info = {}
      this.divisions.forEach(d => {
        // Check for divisions groups first...
        let subDivisions = [...new Set(this.classList.filter(c => c.division === d).map(c => c.settings.sub_division))]
        if (subDivisions.length > 1) {
          info[d] = {
            name: d,
            sub_divisions: subDivisions.map(s => {
              return {
                name: s,
                classes: this.classList.filter(c => c.division === d && (c.settings.sub_division === s))
                // break_by: this.classList.filter(c => c.division === d && (c.settings.sub_division === s))[0].break_type
              }
            }),
            break_by: this.classList.filter(c => c.division === d)[0].break_type,
            subdivision_champions: this.classList.filter(c => c.division === d)[0].settings.division_champions
          }
        } else {
          info[d] = {
            name: d,
            classes: this.classList.filter(c => c.division === d),
            break_by: this.classList.filter(c => c.division === d)[0].break_type,
            subdivision_champions: this.classList.filter(c => c.division === d)[0].settings.division_champions
          }
        }
      })
      return info
    }
  }
}
</script>

<style>

</style>
